/**
 * Client-side feature flags (SDI-style localStorage toggles).
 *
 * Add a key to `features` and an anchor mapping when an upcoming anchor
 * needs a manual opt-in. Flags are toggled at /features.
 */

export const FEATURE_LABELS: Record<string, string> = {};

export type Feature = string;

/** Anchors listed here are hidden until their matching feature is enabled. */
export const ANCHOR_FEATURES: Record<string, Feature> = {};

export function featureEntries(): [Feature, string][] {
    return Object.entries(FEATURE_LABELS);
}

export function featureLabel(feature: Feature): string {
    return FEATURE_LABELS[feature];
}

export function isFeatureEnabled(feature: Feature): boolean {
    return localStorage.getItem(`feature-${feature}`) !== null;
}

/** The feature flag gating a given anchor, or undefined when ungated. */
export function anchorFeature(anchor: string): Feature | undefined {
    return ANCHOR_FEATURES[anchor];
}

export function setFeatureEnabled(feature: Feature, enabled: boolean): void {
    const key = `feature-${feature}`;
    if (enabled) {
        localStorage.setItem(key, "1");
    } else {
        localStorage.removeItem(key);
    }
}
